<template>
  <br/>
  <div class="row">
    <div class="alert alert-success" role="alert" v-if="successMessage">
      {{ successMessage }}
    </div>
    <div class="col-xxl-3 col-xl-4 col-lg-6 col-md-6 col-sm-12 mb-3">
      <button type="button" class="btn btn-primary" data-bs-target="#createPartnerCategoryModal" data-bs-toggle="modal"
              :disabled="disableCreate">
        <span v-if="!disableCreate">Create category</span>
        <span v-else><font-awesome-icon icon="fa-solid fa-sync" spin/></span>
      </button>
    </div>
  </div>
  <div class="table-responsive">
    <table class="table">
      <thead>
      <tr>
        <th scope="col">Id</th>
        <th scope="col">Name</th>
        <th scope="col">Slug</th>
        <th scope="col">Action</th>
      </tr>
      </thead>
      <tbody>
      <tr v-if="totalRecords > 0" v-for="partnerCategory in partnerCategories">
        <td>{{ partnerCategory.id }}</td>
        <td>{{ partnerCategory.key }}</td>
        <td>{{ partnerCategory.slug }}</td>
        <td>
          <button type="button" class="btn btn-info" data-bs-target="#updatePartnerCategoryModal" data-bs-toggle="modal"
                  :disabled="disableCreate" @click="openUpdatePartnerCategoryModal(partnerCategory.id)">
            <span v-if="!disableCreate">Edit</span>
            <span v-else><font-awesome-icon icon="fa-solid fa-sync" spin/></span>
          </button>
        </td>
      </tr>
      <tr v-else-if="loading">
        <td colspan="7" class="text-center">
          <font-awesome-icon icon="fa-solid fa-sync" spin/>
        </td>
      </tr>
      <tr v-else>
        <td colspan="7" class="text-center">No categories</td>
      </tr>
      </tbody>
    </table>
    <div class="d-flex justify-content-between" v-if="totalRecords >= 1">
      <div>
        <div class="p-2">
          <p>Total categories: {{ totalRecords }}</p>
        </div>
      </div>
    </div>
  </div>

  <div class="modal fade" id="createPartnerCategoryModal" data-bs-backdrop="static" data-bs-keyboard="false"
       tabindex="-1"
       aria-labelledby="staticBackdropLabel" aria-hidden="true">
    <div class="modal-dialog">
      <div class="modal-content">
        <div class="modal-header">
          <h1 class="modal-title fs-5" id="staticBackdropLabel">Create Partner category form</h1>
          <button
              id="closeCreatePartnerCategoryBtn"
              type="button"
              class="btn-close"
              data-bs-dismiss="modal"
              aria-label="Close">
          </button>
        </div>
        <div class="modal-body">
          <div class="mb-3">
            <label for="name" class="form-label">Name</label>
            <input type="text" class="form-control me-1" id="createPartnerCategoryKey"
                   v-model="createPartnerCategoryKey">
            <p v-if="validationErrors" v-for="key in validationErrors.key" class="text-danger">{{ key }}</p>
          </div>
          <div class="mb-3">
            <label for="name" class="form-label">Slug</label>
            <input type="text" class="form-control me-1" id="createPartnerCategoryName"
                   v-model="createPartnerCategorySlug">
            <p v-if="validationErrors" v-for="slug in validationErrors.slug" class="text-danger">{{ slug }}</p>
          </div>
        </div>
        <div class="modal-footer">
          <button @click="createPartnerCategory(createPartnerCategoryKey, createPartnerCategorySlug)"
                  type="button" class="btn btn-dark-purple" :disabled="disableCreate">
            <span v-if="!disableCreate">Create</span>
            <span v-else><font-awesome-icon icon="fa-solid fa-sync" spin/></span>
          </button>
        </div>
      </div>
    </div>
  </div>

  <div class="modal fade" id="updatePartnerCategoryModal" data-bs-backdrop="static" data-bs-keyboard="false"
       tabindex="-1"
       aria-labelledby="staticBackdropLabel" aria-hidden="true">
    <div class="modal-dialog">
      <div class="modal-content">
        <div class="modal-header">
          <h1 class="modal-title fs-5" id="staticBackdropLabel">Update Partner category form
            <span v-if="disableCreate">
              <font-awesome-icon icon="fa-solid fa-sync" spin/>
            </span>
          </h1>
          <button id="closeUpdatePartnerCategoryBtn" type="button" class="btn-close" data-bs-dismiss="modal" aria-label="Close"></button>
        </div>
        <div class="modal-body">
          <input type="text" class="form-control me-1" id="updatePartnerCategoryId" v-model="updatePartnerCategoryId" hidden>
          <div class="mb-3">
            <label for="name" class="form-label">Name</label>
            <input type="text" class="form-control me-1" id="updatePartnerCategoryKey" v-model="updatePartnerCategoryKey">
            <p v-if="validationErrors" v-for="key in validationErrors.key" class="text-danger">{{ key }}</p>
          </div>
          <div class="mb-3">
            <label for="name" class="form-label">Slug</label>
            <input type="text" class="form-control me-1" id="updatePartnerCategorySlug" v-model="updatePartnerCategorySlug">
            <p v-if="validationErrors" v-for="slug in validationErrors.slug" class="text-danger">{{ slug }}</p>
          </div>
        </div>
        <div class="modal-footer">
          <button
              @click="updatePartnerCategory(updatePartnerCategoryId, updatePartnerCategoryKey, updatePartnerCategorySlug)"
              type="button" class="btn btn-dark-purple" :disabled="disableCreate">
            <span v-if="!disableCreate">Update</span>
            <span v-else><font-awesome-icon icon="fa-solid fa-sync" spin/></span>
          </button>
        </div>
      </div>
    </div>
  </div>
</template>


<script>
import axios from 'axios';
import _debounce from "lodash/debounce";

export default {
  data() {
    return {
      loading: true,
      partnerCategories: [],
      validationErrors: [],
      totalRecords: 0,
      disableCreate: false,
      successMessage: "",
      createPartnerCategoryKey: "",
      createPartnerCategorySlug: "",
      updatePartnerCategoryId: "",
      updatePartnerCategoryKey: "",
      updatePartnerCategorySlug: ""
    }
  },

  mounted() {
    this.getPartnerCategories();
  },

  methods: {
    debounceGetPartnerCategories: _debounce(function () {
      this.loading = true;
      axios.get(`/admin/partner-categories`)
          .then(response => {
            this.partnerCategories = response.data.data;
            this.totalRecords = response.data.total
            this.loading = false;
          })
          .catch(error => {
            this.loading = false;
            console.log(error);
          });
    }, 500),
    closeModal() {
      document.querySelector('#closeUpdatePartnerCategoryBtn').click();
      document.querySelector('#closeCreatePartnerCategoryBtn').click();
    },
    getPartnerCategories() {
      this.debounceGetPartnerCategories();
    },
    openUpdatePartnerCategoryModal(id) {
      this.disableCreate = true;
      axios.get(`/admin/partner-categories/${id}`)
          .then(response => {
            let responseData = response.data;
            this.updatePartnerCategoryId = responseData.id;
            this.updatePartnerCategoryKey = responseData.key;
            this.updatePartnerCategorySlug = responseData.slug;
            this.disableCreate = false;
          })
          .catch(error => {
            console.log(error);
            this.disableCreate = false;
          });
    },
    createPartnerCategory(createPartnerCategoryKey, createPartnerCategorySlug) {
      this.disableCreate = true;
      axios.post('/admin/partner-categories', {
        'key': createPartnerCategoryKey,
        'slug': createPartnerCategorySlug,
      })
          .then(response => {
            this.successMessage = "Category created successfuly";
            this.getPartnerCategories();
            this.resetPartnerCategoryParams();
            this.resetvalidationErrors();
            this.disableCreate = false;
            this.closeModal();
          })
          .catch(error => {
            if (error.response.status === 422) {
              this.validationErrors = error.response.data.errors;
            }
            this.disableCreate = false;
          });
    },
    updatePartnerCategory(updatePartnerCategoryId, updatePartnerCategoryKey, updatePartnerCategorySlug) {
      this.disableCreate = true;
      axios.patch(`/admin/partner-categories/${updatePartnerCategoryId}`, {
        'key': updatePartnerCategoryKey,
        'slug': updatePartnerCategorySlug
      })
          .then(response => {
            this.successMessage = "Category Partner updated successfuly";
            this.getPartnerCategories();
            this.resetUpdatePartnerCategoryParams();
            this.resetvalidationErrors();
            this.disableCreate = false;
            this.closeModal();
          })
          .catch(error => {
            if (error.response.status === 422) {
              this.validationErrors = error.response.data.errors;
            }
            this.disableCreate = false;
          });
    },
    resetUpdatePartnerCategoryParams() {
      this.updatePartnerCategoryId = "";
      this.updatePartnerCategoryKey = "";
      this.updatePartnerCategorySlug = "";
    },
    resetPartnerCategoryParams() {
      this.createPartnerCategoryKey = "";
      this.createPartnerCategorySlug = "";
    },
    resetvalidationErrors() {
      this.validationErrors = [];
    }
  }

}
</script>